export default __webpack_public_path__ + "static/4_23-4a9b31eac3edee2f3121780f5487af7b.png";